export default function SvgGrave(props) {
    return (
        <svg viewBox="0 0 41 55" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g filter="url(#filter0_d_5731_1341)">
                <path d="M20.2321 0.815918V46.8159M4.49219 17.3516H36.1138" stroke="white" strokeWidth="10"
                      strokeMiterlimit="10"/>
            </g>
            <path d="M20.4219 3.24829V44.1132M6.92188 17.3564H34.0435" stroke="black" strokeWidth="5"
                  strokeMiterlimit="10"/>
            <defs>
                <filter id="filter0_d_5731_1341" x="0.492188" y="0.815918" width="39.625" height="54"
                        filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                   result="hardAlpha"/>
                    <feOffset dy="4"/>
                    <feGaussianBlur stdDeviation="2"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5731_1341"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5731_1341" result="shape"/>
                </filter>
            </defs>
        </svg>
    )
}